<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Vigneti di Caymus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Se mai c'è stato un buon vino che riassumesse la costa dorata della California, lo stile di vita rilassato e il grande sapore, allora il Caymus Cabernet Sauvignon è quello. Molto più piccolo e discreto dei suoi vicini, la lunga esperienza e la comprovata affidabilità di eccellenza di Caymus lo hanno reso una scelta premium nel mercato del vino da investimento.
                    </div>

                    <div class="howto-title2">Un po' di storia</div>
                    <div class="howto-text">
                        Fondato dal contrabbandiere di vino Charlie Wagner alla fine degli anni '60, Caymus è uno dei rari
                        I vigneti californiani hanno una lunga (più o meno) storia familiare. Originario dell'era pre-proibizionista
                        di viticoltori, la famiglia aveva attraversato un periodo difficile negli anni '20 e '30. Percependo un boom
                        l'industria vinicola della Napa Valley, Wagner ha studiato il terreno del vigneto Rutherford della sua famiglia e
                        trovando somiglianze con la regione francese di Bordeaux, ha piantato i 73 acri con Cabernet
                        Sauvignon e Pinot Noir (quest'ultimo vitigno da allora è stato gradualmente eliminato). Nel 1972 ha prodotto il suo
                        prima, annata stellare (che deve ancora essere battuta), seguita da altre due ottime annate. IL
                        la metà degli anni '70 ha visto l'aggiunta dell'enologo Randy Dunn (che in seguito avrebbe fondato Dunn
                        cantine). Suggerì di produrre un vino Selezione Speciale, con invecchiamento avanzato in botti di rovere.
                        Nonostante il vino abbia avuto qualche anno di riposo, le ultime dieci annate del 2007 sono state tutte medio-basse
                        Marcatori aggregati degli anni '90, con un prezzo medio di bottiglia di circa € 150-250, mostrando un ritmo lento ma
                        costante aumento nel periodo di 24 mesi 2017-2019.
                    </div>

                    <div class="howto-title2">Operazioni in espansione ma nessuna riduzione della qualità</div>
                    <div class="howto-text">
                        Sono state rilasciate solo 2.800 bottiglie della prima annata 1972 di Caymus Vineyards e il vino è stato un
                        successo immediato. Il vintage è impossibile da trovare oggi, anche all'asta, così farebbero gli investitori
                        essere saggio cogliere un'opportunità poiché la sua elusività non fa che aumentare il suo tasso di mercato secondario.
                        Questo non deve essere confuso con l'edizione del 40° anniversario del 2012, che è ancora abbastanza diffusa
                        disponibile per circa € 150 bottiglia. Ancora una volta, le edizioni erano limitate, quindi questo prezzo lo farà di più
                        sicuramente lievitare nel tempo. La cantina Napa Valley di Caymus Vineyards rimane l'amata di Wagner
                        primogenito, ma per stare al passo con la domanda del mercato, Wagner acquistò 178 acri nel nord
                        California, con una produzione di circa 200.000 casse all'anno. Le offerte della Napa Valley sono molto,
                        molto più basso, a soli 2.000 per annata.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Caymus-Weinberge</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn es jemals einen guten Wein gab, der die goldene Küste Kaliforniens, den entspannten Lebensstil und den großartigen Geschmack vereint, dann ist es Caymus Cabernet Sauvignon. Caymus ist viel kleiner und unauffälliger als seine Nachbarn und aufgrund seiner langjährigen Erfolgsgeschichte und bewährten Zuverlässigkeit der Exzellenz eine erstklassige Wahl auf dem investierbaren Weinmarkt.
                    </div>

                    <div class="howto-title2">Ein kleiner Hintergrund</div>
                    <div class="howto-text">
                        Caymus wurde Ende der 1960er Jahre vom Weinschmuggler Charlie Wagner gegründet und ist eines der seltenen
                        Kalifornische Weinberge haben eine lange Familiengeschichte. Stammt aus der Zeit vor der Prohibition
                        Als Winzer hatte die Familie in den 1920er und 30er Jahren schwere Zeiten erlebt. Ich spüre einen Boom
                        Wagner untersuchte die Weinindustrie im Napa Valley und untersuchte den Boden des Rutherford-Weinbergs seiner Familie
                        Als er Ähnlichkeiten mit der französischen Region Bordeaux fand, bepflanzte er die 73 Hektar mit Cabernet
                        Sauvignon und Pinot Noir (letztere Rebsorte wurde inzwischen aus dem Sortiment genommen). 1972 produzierte er sein
                        Zuerst ein herausragender Jahrgang (der noch ungeschlagen ist), gefolgt von zwei weiteren hervorragenden Jahrgängen. Der
                        Mitte der 1970er Jahre kam der Winzer Randy Dunn hinzu (der später Dunn gründete).
                        Weingüter). Er schlug vor, einen Special Selection-Wein mit fortgeschrittener Reifung im Eichenfass zu produzieren.
                        Obwohl der Wein einige schlechte Jahre hatte, waren die letzten zehn Jahrgänge aus dem Jahr 2007 alle im unteren bis mittleren Bereich
                        90er-Jahre-Aggregat-Scorer mit einem durchschnittlichen Flaschenpreis von ca. 150–250 €, der sich langsam aber zeigt
                        Stetiger Anstieg über den 24-Monats-Zeitraum von 2017 bis 2019.
                    </div>

                    <div class="howto-title2">Ausweitung des Betriebs, aber keine Qualitätsminderung</div>
                    <div class="howto-text">
                        Nur 2.800 Flaschen des ersten Jahrgangs von Caymus Vineyards aus dem Jahr 1972 wurden auf den Markt gebracht und der Wein war ein
                        sofortiger Erfolg. Der Jahrgang ist heute selbst bei Auktionen nicht mehr zu finden, was Investoren jedoch vermuten würden
                        Seien Sie klug, eine Gelegenheit zu ergreifen, da ihre Flüchtigkeit nur zu ihrem Sekundärmarktpreis beiträgt.
                        Dies ist nicht zu verwechseln mit der 40-Jahre-Jubiläumsausgabe 2012, die immer noch recht weit verbreitet ist
                        erhältlich für ca. 150 € Flasche. Auch hier waren die Auflagen begrenzt, daher wird dieser Preis am meisten gelten
                        sicherlich mit der Zeit steigen. Das Weingut Napa Valley von Caymus Vineyards ist nach wie vor Wagners Liebling
                        Wagner war der Erstgeborene, aber um mit der Marktnachfrage Schritt zu halten, kaufte Wagner 178 Hektar im Norden
                        Kalifornien mit einer Produktion von rund 200.000 Kisten pro Jahr. Das Angebot im Napa Valley ist vielfältig,
                        viel niedriger, bei nur 2.000 pro Jahrgang.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vignobles Caymus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        S'il y a jamais eu un bon vin qui résume la côte dorée de la Californie, un style de vie décontracté et une grande saveur, alors Caymus Cabernet Sauvignon est celui-ci. Beaucoup plus petit et discret que ses voisins, la longue expérience de Caymus et sa fiabilité d'excellence éprouvée en ont fait un choix de choix sur le marché du vin à investir.
                    </div>

                    <div class="howto-title2">Un peu de contexte</div>
                    <div class="howto-text">
                        Fondé par le contrebandier de vin Charlie Wagner à la fin des années 1960, Caymus est l'un des rares
                        Les vignobles californiens ont une longue histoire familiale. Originaire de l'ère pré-interdiction
                        de vignerons, la famille avait connu des moments difficiles dans les années 1920 et 1930. Sentir un boom dans
                        l'industrie vinicole de Napa Valley, Wagner a étudié le sol du vignoble Rutherford de sa famille, et
                        trouvant des similitudes avec la région française de Bordeaux, a planté les 73 acres de Cabernet
                        Sauvignon et Pinot Noir (ce dernier cépage a depuis été supprimé). En 1972, il réalise son
                        un premier millésime stellaire (qui n'a pas encore été battu), suivi de deux autres excellentes années. Le
                        le milieu des années 1970 a vu l'ajout du vigneron Randy Dunn (qui allait plus tard fonder Dunn
                        caves). Il a proposé de produire un vin Sélection Spéciale, avec un élevage poussé en fûts de chêne.
                        Bien que le vin ait quelques années creuses, les dix derniers millésimes de 2007 ont tous été bas-moyens
                        Les buteurs cumulés des années 90, avec un prix moyen de la bouteille d'environ 150 à 250 €, montrent des résultats lents mais
                        augmentation constante sur la période de 24 mois de 2017 à 2019.
                    </div>

                    <div class="howto-title2">Étendre les opérations sans réduire la qualité</div>
                    <div class="howto-text">
                        Seulement 2 800 bouteilles du premier millésime 1972 de Caymus Vineyards ont été lancées et le vin était un
                        succès immédiat. Le millésime est introuvable aujourd'hui, même aux enchères, donc les investisseurs
                        soyez sage de saisir une opportunité car son caractère insaisissable ne fait qu'ajouter à son taux de marché secondaire.
                        A ne pas confondre avec l'édition 2012 du 40e anniversaire, qui est encore assez largement
                        disponible pour environ 150 € la bouteille. Encore une fois, les éditions étaient limitées, donc ce prix sera le plus
                        augmentera certainement avec le temps. La cave de Napa Valley de Caymus Vineyards reste la bien-aimée de Wagner
                        premier né, mais afin de répondre à la demande du marché, Wagner a acheté 178 acres dans le nord
                        Californie, avec une production d'environ 200 000 caisses par an. Les offres de Napa Valley sont nombreuses,
                        beaucoup plus bas, à seulement 2 000 par millésime.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Caymus vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        If there ever was a fine wine that summed California’s golden coast, laid-back lifestyle and big flavour, then Caymus Cabernet Sauvignon is it. Much smaller and unobtrusive than its neighbours, Caymus’ long-track record and proven reliability of excellence have made it a premium choice in the investable wine market.
                    </div>

                    <div class="howto-title2">A little background</div>
                    <div class="howto-text">
                        Founded by wine bootlegger Charlie Wagner in the late 1960s, Caymus is one of the rare
                        Californian vineyards to have a long(ish) family history. Hailing from the pre-prohibition era
                        of winemakers, the family had fallen on hard time during the 1920s and 30s. Sensing a boom in
                        the Napa Valley wine industry, Wagner studied his family’s Rutherford vineyard’s soil, and
                        finding similarities with the French Bordeaux region, planted the 73-acres with Cabernet
                        Sauvignon and Pinot Noir (the latter grape has since been phased out). In 1972 he produced his
                        first, stellar vintage (which has yet to be beaten), followed by two more excellent years. The
                        mid-1970s saw the addition of winemaker Randy Dunn (who would later go on to found Dunn
                        wineries). He suggested producing a Special Selection wine, with advanced oak-barrel ageing.
                        Despite the wine having a few off years, the past ten vintages from 2007 have all been low-mid
                        90s aggregate scorers, with an approximate €150-250 average bottle price, showing slow but
                        steady increase over the 24-month period from 2017-2019.
                    </div>

                    <div class="howto-title2">Expanding operations but no reduction in quality</div>
                    <div class="howto-text">
                        Just 2,800 bottles of Caymus Vineyards first 1972 vintage were released and the wine was an
                        immediate success. The vintage is impossible to find today, even at auction, so investors would
                        be wise to snap up an opportunity as its elusiveness only adds to its secondary market rate.
                        This is not to be confused with the 2012 40th anniversary edition, which is still quite widely
                        available for approximately €150 bottle. Again, editions were limited so this price will most
                        certainly rise over time. Caymus Vineyards’ Napa Valley winery remains Wagner&#39;s beloved
                        first born, but in order to keep up with market demand, Wagner purchased 178-acres in northern
                        California, with a production of around 200,000 cases a year. Napa Valley offerings are much,
                        much lower, at just 2,000 per vintage.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CaymusVineyards",
    head: {
        title: 'Caymus vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unparalleled flavors of Napa Valley with Caymus Vineyards, a renowned wine producer known for its rich, bold, and full-bodied Cabernet Sauvignon. Indulge in the exceptional quality and taste of Caymus\' hand-crafted wines and experience the essence of Napa.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
